<template>
	<div class="app">
		<NuxtLoadingIndicator color="var(--color-primary)" />
		<NuxtLayout>
			<NuxtPage />
			<GlobalToast />
		</NuxtLayout>
	</div>
</template>

<script setup lang="ts">
onErrorCaptured((error, instance, info) => {
	console.error('Error captured in ParentComponent:', error, instance, info)

	return false
})
</script>
